import React from 'react';

const Icon = (props) => {

    if(props.animated){
	    return (
		    <span className={props.className ? `icon ${props.className}` : 'icon'} onClick={props.onClick}>
                <i className={`fa fa-${props.name} fa-${props.animated}`} style={{color: `${props.color}`, width: `${props.width}`, height: `${props.height}`}} aria-hidden="true"/>
            </span>
	    );
    } else {
	    return (
		    <span className={props.className ? `icon ${props.className}` : 'icon'} onClick={props.onClick} id={props.id}>
                <i className={`fa fa-${props.name}`} style={{color: `${props.color}`, width: `${props.width}`, height: `${props.height}`}} aria-hidden="true"/>
	        </span>
	    );
    }

};

export default Icon;
